import { p as popperGenerator } from './createPopper-LBVkobRj.js';
import { e as eventListeners } from './modifiers/eventListeners-DDxno5DN.js';
import { p as popperOffsets } from './modifiers/popperOffsets-CeR4syqv.js';
import { c as computeStyles } from './modifiers/computeStyles-Boy31BNq.js';
import { a as applyStyles } from './modifiers/applyStyles-DJHyPKs0.js';
import { o as offset } from './modifiers/offset-39rjAF28.js';
import { f as flip } from './modifiers/flip-K_FO-uSg.js';
import { p as preventOverflow } from './modifiers/preventOverflow-B-QavoxQ.js';
import { a as arrow } from './modifiers/arrow-B_DZyrGV.js';
import { h as hide } from './modifiers/hide-DNpmlFtq.js';

var defaultModifiers = [eventListeners, popperOffsets, computeStyles, applyStyles, offset, flip, preventOverflow, arrow, hide];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

export { createPopper as c };
//# sourceMappingURL=popper-BwQA918Y.js.map
